import util from '@/common/util';
import { params2linkHash } from '@/common/search-request';
import { numberFormat } from '@/common/format';
import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { usePageStore } from '@/store';

export default {
    i18next: {
        ns: 'md-search-result'
    },
    data: function() {
        return {
            url: ''
        }
    },
    watch: {
        locationCondition: {
            immediate: true,
            deep: true,
            async handler(newValue) {
                this.url = util.setQueryField(await params2linkHash.call(this, newValue, this.page), '/snapshot');
            }
        }
    },
    computed: {
        ...rootMapState(usePageStore, {
            "isSearchCenter": store => store.isSearchCenter,
            "currencySymbol": store => store.currency.symbol,
            "page": store => store.page
        }),
        ...mapState({
            "marketReport": store => store.marketReport,
            "searchParams": store => store.searchParams,
            "locationCondition": "locationCondition"
        }),
        
        
        
        changeState() {
            const { avgSoldPrice, avgSoldPriceChangeVal } = this.marketReport;
            if (avgSoldPrice && avgSoldPriceChangeVal) {
                const ratio = avgSoldPriceChangeVal / avgSoldPrice;
                if (Math.abs(ratio) < 0.001) {
                    return 0;
                }
                return ratio > 0 ? 1 : 2;
            }
            return 0;
        },
        desc() {
            if (this.changeState === 0) {
                return this.$t('md-search-result.remainedStable');
            }
            return this.$t(
                this.changeState === 1
                    ? 'md-search-result.increasedBy'
                    : 'md-search-result.decreasedBy',
                {
                    num:
                        this.currencySymbol +
                        numberFormat(
                            Math.abs(this.marketReport.avgSoldPriceChangeVal),
                            true
                        )
                }
            );
        }
    }
};
